import styled from 'styled-components'

const CustomFieldsListWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
`
CustomFieldsListWrapper.displayName = 'CustomFieldsListWrapper'
export default CustomFieldsListWrapper
